import React, { Component } from "react";

//Other components for the page
//import Slider from './Slider.js';
import SliderNew from "./SliderNew.js";
import AboutUs from "./AboutUs.js";
import ServiceInformation from "./ServiceInformation.js";
//import ServiceInformation from './COVIDService.js';
import Ministries from "./Ministries.js";
import Events from "./Events.js";
import LatestSermon from "./LatestSermon.js";
// import Team from "./Team.js";
//import COVIDMinistries from './COVIDMinistries.js';
//import ConnectToOnlineGatherings from './ConnectToOnlineGatherings.js';
//import ConnectToMidWeek from './ConnectToMidWeek.js';
// import LookIntoChristianFaith from "./LookIntoChristianFaith";
// import ConnectToLivestream from "./ConnectToLivestream.js";

class FrontPageWrapper extends Component {
	render() {
		return (
			<div id="wrapper">
				<SliderNew />
				<ServiceInformation background="" />
				{/* <ConnectToLivestream background="dark" /> */}
				<AboutUs background="dark" />
				<LatestSermon background="" />
				<Ministries background="dark" />
				{/* <LookIntoChristianFaith background="dark" /> */}

				<Events background="" />
				{/* <Team background="dark" /> */}
			</div>
		);
	}
}

export default FrontPageWrapper;
